module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_dogbirthday-25a82278927aefd3f2b5b9b2f286d4de.svg";